document.getElementById('searchInput').addEventListener('input', function () {
    var searchValue = normalizeText(this.value).toLowerCase();
    var listItems = document.querySelectorAll('.siteMap-container li');
    var components = document.querySelectorAll('.siteMap-component');

    listItems.forEach(function (item) {
        var anchors = item.querySelectorAll('a');
        var includeCategory = Array.from(anchors).some(function (anchor) {
            var text = normalizeText(anchor.textContent).toLowerCase();

            if (text.includes(searchValue)) {
                return true; // Exibe o item se o texto corresponder
            }

            return false; // Oculta o item se o texto não corresponder
        });

        item.style.display = includeCategory ? 'block' : 'none';
    });

    components.forEach(function (component) {
        var componentText = normalizeText(component.textContent).toLowerCase();

        if (componentText.includes(searchValue)) {
            component.style.display = 'block'; // Exibe o componente se o texto corresponder
        } else {
            component.style.display = 'none'; // Oculta o componente se o texto não corresponder
        }
    });
});

function normalizeText(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
